import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Row, Col } from "react-bootstrap";
import { FaEdit, FaWindowClose } from "react-icons/fa";
import { config } from "../../../CommonUtilities/CommonUrl/CommonUrls";
import { CommonAxiosGet, CommonAxiosPost, } from "../../../CommonUtilities/CommonAxios/CommonAxios";
import { CommonPageHeading } from "../../../CommonUtilities/CommonHeading/CommonPageHeading";
import { onClearFieldValue } from "../../../CommonUtilities/CommonFunctions/CommonFunction";
import { ACADEMIC_YEAR, alphaNumeric_VALIDATION, CONTEXT_NAME, ERROR_MSG, HT_Msg } from "../../../CommonUtilities/Validations/RegularExpAndVar";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import Swal from "sweetalert2";
import Sweetalert from "../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts";
import { IoIosArrowDown } from "react-icons/io";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { ScoreDetails } from "../Results/Results";

export const CandidateBasicDetails = (props) => {
  const { showRowData } = props;

  return (
    <table border="1" role="presentation" style={{ width: "100%", borderCollapse: "collapse", background: "ivory" }}
      className="table table-responsive">
      <tbody>
        <tr>
          <td>Candidate ID</td>
          <td>: <strong>{showRowData?.candidate_id}</strong></td>
          <td>Candidate Name</td>
          <td>: <strong>{showRowData?.applicant_name}</strong></td>
          <td>DOB</td>
          <td>: <strong>{showRowData?.dob_char}</strong></td>
        </tr>
        <tr>
          <td>Gender</td>
          <td>: <strong>{showRowData?.gender}</strong></td>
          <td>Father </td>
          <td>: <strong>{showRowData?.father_name}</strong></td>
          <td>Caste</td>
          <td>:<strong> {showRowData?.caste}</strong></td>
        </tr>
        <tr>
          <td> Candidate District</td>
          <td>: <b>{showRowData?.dist_name}</b> </td>
          <td>PH</td>
          <td>: <b>{showRowData?.ph_eligible}</b></td>
          <td>Ex-Servicemen</td>
          <td> : <b>{showRowData?.ex_service}</b></td>
        </tr>
      </tbody>
    </table>
  );
};
export default function TetObjections() {

  const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
  const [postData, setPostData] = useState([]);
  const [showOtpBtn, setOtpBtn] = useState(true);
  const [resendOtp, setResendOtp] = useState(false);
  const getDataFunction = async () => {
    const url = `${config.url.DSC_Read_URL}getScoreCard`;
    try {
      const response = await CommonAxiosGet(url);
      if (response?.data?.status === true) {
        const posts = response?.data?.data || [];
        setPostData(posts);
      } else {
        setPostData([]);
      }
    } catch (error) {
      console.error("Error in getDataFunction", error);
      setPostData([]);
    }
  };
  const [showTETData, setTETData] = useState([]);
  const getDataFunctionTET = async () => {
    // const url = `${config.url.DSC_Read_URL}candidate-tet-papers-for-corrections`;
    const url = `${config.url.DSC_Read_URL}v2/candidate-tet-papers-for-corrections`;
    try {
      const response = await CommonAxiosGet(url);
      if (response?.data?.status === true) {
        const tet = response?.data?.data || [];
        setTETData(tet);
      } else {
        setTETData([]);
      }
    } catch (error) {
      console.error("Error in getDataFunctionResult", error);
      setTETData([]);
    }
  };
  useEffect(() => {
    getDataFunction();
    getDataFunctionTET();
  }, []);

  function getData(ht) {
    let paper = candidateFormik?.values?.paper;
    let tet_sub = candidateFormik?.values?.tetSubject;
    let tet_med = candidateFormik?.values?.tetMedium;
    if (ht && paper) {
      const villUrl = config.url.DSC_Read_URL + "tet-data?htNo=" + ht + "&paper=" + paper + "&tetSubject=" + tet_sub + "&tetMedium=" + tet_med;
      CommonAxiosGet(villUrl).then((response) => {
        if (response?.data?.status === true) {
          const score_data = response.data.data[0];
          candidateFormik.setFieldValue('marks', score_data?.score);
          candidateFormik.setFieldValue('year', score_data?.yop);
          candidateFormik.setFieldValue('nameInTet', score_data?.candidate_name);
          candidateFormik.setFieldValue('fatherName', score_data?.father_name);
          candidateFormik.setFieldValue('weightage', score_data?.tet_weight);
        } else {
          Sweetalert("No TET Details Found", 'error')
          candidateFormik.setFieldValue('year', '');
          candidateFormik.setFieldValue('marks', "");
          candidateFormik.setFieldValue('nameInTet', "");
          candidateFormik.setFieldValue('fatherName', ''); candidateFormik.setFieldValue('weightage', '');
        }
      });
    } else {
      Sweetalert("Please Enter Valid Hall Ticket No.", 'error')
    }
  }
  const [modalStatus, setModalStatus] = useState(false);
  const handleOpen = () => { setModalStatus(true); };
  const closeModal = () => { setModalStatus(false); };
  const ValidationSchema = Yup.object().shape({
    tetType: Yup.string().required(ERROR_MSG).nullable(),
    htNo: Yup.string()
      .required(ERROR_MSG)
      .nullable()
      .matches(alphaNumeric_VALIDATION, HT_Msg)
      .min(4, "Invalid Number")
      .max(15, "Invalid Number"),
    // .test('already-exists', 'Already Exists!', (value, context) => {
    //   const existingHt = tetRowData?.tet_ht_no;
    //   if (!value) return true; // Let `.required()` handle empty

    //   if (existingHt === value) {
    //     return new Yup.ValidationError('Already Exists!', value, context.path);
    //   }

    //   return true;
    // }),
    year: Yup.string().when("tetType", {
      is: (tetType) => (tetType === "CTET"),
      then: Yup.string().required(ERROR_MSG).nullable(),
      oterwise: Yup.string(),
    }),
    // paper: Yup.string().when("tetType", {
    //   is: () => (tetRowData?.tet_paper === 'Paper 2A' || tetRowData?.tet_paper === 'Paper 1A'),
    //   then: (schema) => schema.required(ERROR_MSG).nullable(),
    //   otherwise: (schema) => schema, // not 'oterwise'
    // }),
    marks: Yup.string()
      .nullable()
      .test('is-valid-mark', 'Invalid Marks!', (value, context) => {
        const caste = postData[0]?.caste || '';
        const isExServiceMen = postData[0]?.ex_service || '';
        const isPh = postData[0]?.ph_eligible || '';
        if (value === null || value === '') {
          return new Yup.ValidationError('Marks cannot be empty', value, context.path);
        }

        const num = parseFloat(value);
        if (isNaN(num) || num > 150) {
          return new Yup.ValidationError('Invalid Marks', value, context.path);
        }

        if (
          ['SC', 'ST', 'SC-GR I', 'SC-GR II', 'SC-GR III', 'SC-A', 'SC-B', 'SC-C'].includes(caste) ||
          isPh === 'YES' || isExServiceMen === 'YES'
        ) {
          if (num < 60) {
            return new Yup.ValidationError(
              'Minimum 60 marks required for SC/ST/PH/Ex-Servicemen',
              value,
              context.path
            );
          }
        } else if (['BC-A', 'BC-B', 'BC-C', 'BC-D', 'BC-E'].includes(caste)) {
          if (num < 75) {
            return new Yup.ValidationError(
              'Minimum 75 marks required for BC category',
              value,
              context.path
            );
          }
        } else if (caste === 'OC' || caste === 'OC (EWS)') {
          if (num < 90) {
            return new Yup.ValidationError(
              'Minimum 90 marks required for OC/OC (EWS)',
              value,
              context.path
            );
          }
        } else {
          return new Yup.ValidationError('Unknown caste category', value, context.path);
        }

        return true;
      }),

  })
  const candidateFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      tetType: "", year: "", paper: "", otp: '', weightage: "", tetSubject: "",
      htNo: "", marks: "", nameInTet: "", fatherName: "", selfCheck1: "", selfCheck2: "", selfCheck3: "",
    },
    onSubmit: (values, { resetForm }) => {
      if (values?.selfCheck1 && values?.selfCheck2 && values?.selfCheck3) {
        sendOtp(values, resetForm);
      } else {
        Sweetalert('Please confirm the above declarations to proceed.', 'warning');
      }
    },
    validationSchema: ValidationSchema,
  });
  function submitValues() {
    let url = config.url.DSC_URL + "candidate-tet-corrections";
    CommonAxiosPost(url, candidateFormik?.values).then((res) => {
      if (res?.data?.status === true) {
        Swal.fire({
          text: "Successfully Updated",
          icon: "success",
          confirmButtonColor: "#3085d6",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          confirmButtonText: "OK",
        }).then((resp) => {
          if (resp.isConfirmed) {
            closeModal();
            getDataFunctionTET();
          }
        });
      } else {
        Sweetalert(res?.data?.sdesc, "error");
      }
    });
  }
  function sendOtp(values, resetForm) {
    Swal.fire({
      title: 'Are you Sure Want to Submit?',
      html: `No further changes will be entertained.`, icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Send OTP",
    }).then((res) => {
      if (res.isConfirmed) {
        let otpUrl = config.url.DSC_URL + "candidate-tet-corrections-otp"
        CommonAxiosPost(otpUrl, values).then((rres) => {
          if (rres?.data?.status === true) {
            setOtpBtn(false)
            setTimer(180);
          }
          else if (rres?.data?.scode === '03') {
            Sweetalert(rres?.data?.sdesc, "warning");
            resetForm()
          } else {
            resetForm();
            Sweetalert(rres?.data?.sdesc, "warning")
          }
        })
      }
    })
  }
  const [tetRowData, setTetRowData] = useState();
  const [timer, setTimer] = useState(180);
  useEffect(() => {
    let interval = null;
    if (!showOtpBtn) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer > 0) {
            if (prevTimer < 122) {
              setResendOtp(true);
              return prevTimer - 1;
            } else if (prevTimer > 1) {
              return prevTimer - 1;
            }
            else {
              clearInterval(interval);
              setResendOtp(true);
              return 0;
            }
          }
        });
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [showOtpBtn]);

  const formatTime = (timeInSeconds) => {
    if (isNaN(timeInSeconds) || timeInSeconds < 0) {
      return "0:00";
    }
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const resendOTP = () => {
    candidateFormik.setFieldValue("otp", "")
    let values = candidateFormik?.values
    sendOtp(values)
  };

  return (
    <div>
      <CommonPageHeading heading="TET Details Updation" />
      <div className="pop">
        <Modal show={modalStatus} size="xl" className="mt-5 modal_xl">
          <Modal.Header style={{ backgroundColor: "rgb(220 162 77)", height: "60px" }} >
            <Modal.Title>&nbsp; {CONTEXT_NAME} - {ACADEMIC_YEAR} - Update of TET Details</Modal.Title>
            <button type="button" onClick={() => { closeModal() }} className='btn btn-end'
              style={{ fadeType: "out" }} variant="danger" aria-label="Close">
              <h4><FaWindowClose className="text-danger" size={32} /></h4>
            </button>
          </Modal.Header>
          <Modal.Body className="bgModal">
            <FormikProvider value={candidateFormik}>
              <Form className="form-section" onSubmit={candidateFormik.handleSubmit} onChange={candidateFormik.handleChange} >
                <div className="table-responsive">
                  <CandidateBasicDetails showRowData={postData[0]} />
                  <table className="table table-condensed table-bordered table-responsive mb-0 mt-0" role="presentation">
                    <thead style={{ borderCollapse: "collapse", background: "ghostwhite" }}>
                      <tr><td style={{ width: '17%' }}><Form.Label className="input-lable">Paper (Subject) <font className='text-danger'>*</font></Form.Label></td>
                        <td style={{ width: '3%' }}><Form.Label className="input-lable">TET Type <font className='text-danger'>*</font></Form.Label></td>
                        <td style={{ width: '32%' }}><Form.Label className="input-lable">HallTicket No. <font className='text-danger'>*</font></Form.Label></td>
                        <td style={{ width: '5%' }}><Form.Label className="input-lable">Year of Passing <font className='text-danger'>*</font></Form.Label></td>
                        <td style={{ width: '15%' }}><Form.Label className="input-lable">Candidate Name in TET</Form.Label></td>
                        <td style={{ width: '15%' }}><Form.Label className="input-lable">Father Name in TET</Form.Label></td>
                        <td style={{ width: '10%' }}><Form.Label className="input-lable">Score <font className='text-danger'>*</font></Form.Label></td>
                        <td style={{ width: '3%' }}><Form.Label className="input-lable">Weightage</Form.Label></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{tetRowData?.tet_subject_name}
                          {/* {(tetRowData?.tet_paper === 'Paper 1B' || tetRowData?.tet_paper === 'Paper 2B') ? tetRowData?.tet_paper :
                          (tetRowData?.tet_paper === 'Paper 1A') ? (
                            <div className="">
                              <Form.Group>
                                <Field as="select" className=""
                                  name='paper' onChange={() => {
                                    onClearFieldValue(candidateFormik, ['marks', 'fatherName', 'nameInTet', 'year', 'htNo', 'weightage'])
                                  }}>
                                  <option value="">Select</option>
                                  <option value='Paper 1A'>1(A)</option>
                                  <option value='Paper 1B'>1(B)</option>
                                </Field>  </Form.Group>
                            </div>) : (tetRowData?.tet_paper === 'Paper 2A') ? (
                              <div className="">
                                <Form.Group><Field as="select" className=""
                                  name='paper' onChange={() => {

                                    onClearFieldValue(candidateFormik, ['marks', 'fatherName', 'nameInTet', 'year', 'htNo', 'weightage'])
                                  }}>
                                  <option value="">Select</option>
                                  <option value='Paper 2A'>2(A)</option>
                                  <option value='Paper 2B'>2(B)</option>
                                </Field>  </Form.Group>
                              </div>) : ''} */}
                        </td>
                        <td>
                          <Form.Group> <Field as="select" name="tetType"
                            onChange={() => {
                              onClearFieldValue(candidateFormik, ['marks', 'fatherName', 'nameInTet', 'year', 'htNo', 'weightage'])
                            }}>
                            <option value="">Select</option>
                            <option value="APTET">AP TET</option>
                            <option value="CTET">CENTRAL TET (CTET)</option>
                          </Field> <ErrorMessage name="tetType" component="div" className="text-error" /></Form.Group>
                        </td>
                        <td><label><Field type="text" name="htNo"
                          onChange={() => {
                            onClearFieldValue(candidateFormik, ['marks', 'fatherName', 'nameInTet', 'year', 'weightage'])
                          }}
                        /> <button type="button" className="btn btn-sm btn-primary" onClick={() => {
                          let ht = candidateFormik?.values?.htNo
                          let ht_no = ht.trim()
                          if (candidateFormik?.values?.tetType === 'APTET') {
                            getData(ht_no)
                          }
                        }}>Get</button>
                        </label>
                          <ErrorMessage name="htNo" component="div" className="text-error" /></td>
                        <td>{candidateFormik?.values?.tetType === 'CTET' ?
                          <div className="input-div position-relative">
                            <Form.Group>
                              <Field as="select" className="input-field form-control" name="year" >
                                <option value=""></option>
                                <option value="2011">2011</option>
                                <option value="2012">2012</option>
                                <option value="2013">2013</option>
                                <option value="2014">2014</option>
                                <option value="2015">2015</option>
                                <option value="2016">2016</option>
                                <option value="2017">2017</option>
                                <option value="2018">2018</option>
                                <option value="2019">2019</option>
                                <option value="2020">2020</option>
                                <option value="2021">2021</option>
                                <option value="2022">2022</option>
                                <option value="2023">2023</option>
                                <option value="2024">2024</option>
                              </Field>
                            </Form.Group>
                            <IoIosArrowDown className="dropdown-icon" />
                          </div> : candidateFormik?.values?.year}
                          <ErrorMessage name="year" component="div" className="text-error" />
                        </td>
                        <td>{candidateFormik?.values?.tetType === 'CTET' ? <>
                          {/* <Field type="text" name="nameInTet" className="input-field form-control" /> */}
                        </> : candidateFormik?.values?.nameInTet}</td>
                        <td>{candidateFormik?.values?.tetType === 'CTET' ? <>
                          {/* <Field type="text" name="fatherName" className="input-field form-control" /> */}
                        </> : candidateFormik?.values?.fatherName}</td>
                        <td>{candidateFormik?.values?.tetType === 'CTET' ? <><Field type="text" name="marks" className="input-field form-control" /></> : candidateFormik?.values?.marks}<ErrorMessage name="marks" component="div" className="text-error" /></td>
                        <td>{candidateFormik?.values?.tetType !== 'CTET' && candidateFormik?.values?.weightage}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <Row className='pb-0 pt-2 mx-0 alert alert-warning'>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}> &nbsp;
                    <Field
                      type="checkbox"
                      name="selfCheck1"
                      className="form-sub"
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        candidateFormik.setFieldValue('selfCheck1', isChecked ? true : null);
                      }}
                    /> &nbsp;I hereby declare that the TET details provided above are true and correct and also belongs to me.
                    <ErrorMessage
                      name="selfCheck1"
                      component="div"
                      className="text-error"
                    /> </Col>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}> &nbsp;
                    <Field
                      type="checkbox"
                      name="selfCheck2"
                      className="form-sub"
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        candidateFormik.setFieldValue('selfCheck2', isChecked ? true : null);
                      }}
                    /> &nbsp;I hereby declare that the name as mentioned in my DSC application and the name recorded in my TET certificate are identical and pertains to me.
                    <ErrorMessage
                      name="selfCheck2"
                      component="div"
                      className="text-error"
                    /> </Col>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}> &nbsp;
                    <Field
                      type="checkbox"
                      name="selfCheck3"
                      className="form-sub"
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        candidateFormik.setFieldValue('selfCheck3', isChecked ? true : null);
                      }}
                    /> &nbsp;I hereby declare that the score given by me is the maximum score.
                    <ErrorMessage
                      name="selfCheck3"
                      component="div"
                      className="text-error"
                    /> </Col>

                </Row>
                <Row className='pb-4'>
                  <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                    {showOtpBtn === true ?
                      <Button variant="secondary" type="submit" className="bg-dark submit-btn mt-4">
                        Generate OTP </Button>
                      : showOtpBtn === false ?
                        <React.Fragment>
                          {resendOtp === false ?
                            <Form.Label className="input-lable mb-3 mt-4">OTP Sent to &nbsp;
                              <b className='text-primary'>{loginreducer?.mobile_no} </b></Form.Label> :
                            resendOtp === true ? <React.Fragment>
                              <Form.Label className="input-lable mt-2">Didn't receive code? </Form.Label>
                              <Button variant="primary" type="button" className="submit-btn"
                                onClick={() => { resendOTP() }}>Resend OTP </Button></React.Fragment>

                              : ''
                          }
                        </React.Fragment> : ''}
                  </Col>
                  {showOtpBtn === false ? <React.Fragment>
                    <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                      <Form.Label className="input-lable mb-3 mt-4">Time Remaining:  {formatTime(timer)}</Form.Label>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                      <Form.Group controlId="otp">
                        <Field
                          type="text"
                          name="otp"
                          className="input-field form-control mt-4"
                          placeholder="Enter OTP"
                          maxLength={6}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3} className='pt-2' >
                      <Button variant="success" type="button" className="submit-btn btn-success float-end mt-3" onClick={() => { submitValues() }}>
                        Submit
                      </Button>
                    </Col>
                  </React.Fragment> : ''}
                </Row>
              </Form>
            </FormikProvider>
          </Modal.Body>
        </Modal >
      </div >

      <div className="table-responsive">
        <CandidateBasicDetails showRowData={postData[0]} />
        <ScoreDetails resultData={postData} from="obj" />
        {showTETData?.length > 0 ? (
          <div className="personal-block">
            <div className="table-responsive mb-3">
              <table className="table table-condensed table-bordered table-responsive mb-0 mt-0" role="presentation"
                style={{ borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "ghostwhite" }}>
                    <th colSpan={6} className="text-center">TET Details Required for the Applied Posts</th>
                  </tr>
                  <tr>
                    <th>Paper (Subject)</th>
                    <th>Tet Type</th>
                    {/* <th>Paper</th> */}
                    <th>Year of Passing</th>
                    <th>HallTicket No.</th>
                    <th>Marks</th>
                    <th>Edit</th>
                  </tr>
                </thead>
                <tbody>
                  {showTETData?.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>{item?.tet_subject_name}</td>
                        <td>{item?.new_tet_type ? item?.new_tet_type : item?.tet_type}</td>
                        {/* <td>{item?.new_paper ? item?.new_paper : item?.tet_paper}</td> */}
                        <td>{item?.new_year ? item?.new_year : item?.tet_pass_year}</td>
                        <td>{item?.new_ht_no ? item?.new_ht_no : item?.tet_ht_no}</td>
                        <td>{item?.new_marks ? item?.new_marks : item?.tet_marks}</td>
                        <td>
                          {item?.new_ht_no ? <span className="text-danger">Pending For verification</span> : <button type="button" className="btn btn-end btn-primary btn-sm"
                            onClick={() => {
                              handleOpen(); setTetRowData(item);
                              candidateFormik.setFieldValue('tetMedium', item?.post_medium);
                              candidateFormik.setFieldValue('oldPaper', item?.tet_paper);
                              candidateFormik.setFieldValue('paper', item?.tet_paper);
                              candidateFormik.setFieldValue('tetSubject', item?.tet_subject_id);
                              setOtpBtn(true); setResendOtp(false);
                              onClearFieldValue(candidateFormik, ['htNo', 'selfCheck1', 'selfCheck2', 'selfCheck3', 'marks', 'tetType', 'nameInTet', 'otp', 'fatherName', 'year'])
                            }}><FaEdit /> Edit </button>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ) : (<></>)}
      </div>
    </div >
  );
}
